import { hbs } from 'ember-cli-htmlbars';
export default hbs("<button type=\"button\" class=\"u-unstyled-button\" ...attributes {{on \"click\" (optional @onClick)}}>\n  {{yield}}\n</button>")